import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatCardModule } from '@angular/material/card'
import { MatIcon } from '@angular/material/icon'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatExpansionModule } from '@angular/material/expansion'
import { MatInput } from '@angular/material/input'
import { MatDividerModule } from '@angular/material/divider'
import { ViaCepService } from '../../../core/services/address/via-cep/via-cep.service'
import { EmployeeStatusService } from '../../../core/services/employee/employee-status/employee-status.service'
import { EmployeeService } from '../../../core/services/employee/employee/employee.service'
import { AddressTypeService } from '../../../core/services/address/address-type/address-type.service'
import { HabitsService } from '../../../core/services/employee/employee-role/habits.service'
import { HealthUnitService } from '../../../core/services/health-unit/location/health-unit.service'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../core/models/response.model'
import {MatSlideToggle} from '@angular/material/slide-toggle';
import {NgxMaskDirective} from 'ngx-mask';
import {MunicipalityService} from '../../../core/services/municipality/municipality/municipality.service';
import {
  MunicipalityCentralService
} from '../../../core/services/municipality-central/municipality/municipality-central.service';
import {MatOption} from '@angular/material/core';
import {MatSelect} from '@angular/material/select';

@Component({
  selector: 'municipality-central-edit',
  imports: [
    ReactiveFormsModule,
    MatButton,
    MatProgressSpinner,
    MatExpansionModule,
    MatFormFieldModule,
    MatCardModule,
    MatIcon,
    MatInput,
    MatDividerModule,
    MatSlideToggle,
    NgxMaskDirective,
    MatOption,
    MatSelect,
  ],
  templateUrl: './municipality-central-edit.component.html',
  styleUrl: './municipality-central-edit.component.scss',
  providers: [
    ViaCepService,
    EmployeeStatusService,
    EmployeeService,
    HabitsService,
    AddressTypeService,
  ],
  standalone: true,
})
export class MunicipalityCentralEditComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private municipalityService: MunicipalityService,
    private municipalityCentralService: MunicipalityCentralService,
    private snackbar: SnackbarCustomService,
    private viaCepService: ViaCepService,
    private dialogRef: MatDialogRef<MunicipalityCentralEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.item = this.data.item
  }

  @Output() responseEdit = new EventEmitter()
  form: FormGroup = new FormGroup({})
  listMunicipios: any[] = []
  loading: boolean = false
  item: any = {}
  ngOnInit(): void {
    this.createForm()
    this.listMunicip()
    const itemId = this.item?.hiperdia_id || this.item?.id
    if (itemId && (!this.item.logradouro || !this.item.email || !this.item.telefone_whatsapp)) {
      this.municipalityCentralService.getLocationbyId(itemId).subscribe({
        next: (response: any) => {
          if (response?.data) {
            this.item = { ...this.item, ...response.data }
            this.createForm()
          }
        },
        error: (err) => console.error(err)
      })
    }
  }
  listMunicip(){
    this.municipalityService.listActiveMunicipality().subscribe({
      next: (response: any) => {
        if(response.data){
          this.listMunicipios = response.data
        }
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
    })
  }
  close() {
    this.dialogRef.close()
  }

  createModel() {
    return {
      id: this.item?.hiperdia_id || this.item?.id,
      nome_fantasia: this.form.get('fantasy_name')?.value,
      razao_social: this.form.get('corporate_name')?.value,
      logradouro: this.form.get('street')?.value,
      municipio_id: this.form.get('municipality')?.value,
      email: this.form.get('email')?.value,
      senha: this.form.get('password')?.value === "••••••" ? null : this.form.get('password')?.value,
      cnpj: this.form.get("cnpj")?.value,
      numero: this.form.get('number')?.value,
      telefone_1: '55'+this.form.get('phone_number')?.value,
      telefone_whatsapp: '55'+this.form.get('phone_number_whatsapp')?.value,
      cep: this.form.get('postal_code')?.value,
      bairro: this.form.get('neighborhood')?.value,
      cidade: this.listMunicipios.find(
        (item: any) => item.id === this.form.get('municipality')?.value
      )?.nome,
      estado: this.form.get('state')?.value,
      status_id: this.form.get('active')?.value === true ? 1 : 2,
    }
  }

  createForm(): void {
    let hiperdia: any = this.item || {}
    const cleanPhone = (phone: any): string => {
      if (!phone) return ''
      const str = String(phone).trim()
      return str.startsWith('55') ? str.slice(2) : str
    }
    this.form = this.formBuilder.group({
      fantasy_name: [hiperdia?.nome_fantasia || '', [Validators.required]],
      corporate_name: [hiperdia?.razao_social || '', [Validators.required]],
      street: [hiperdia?.logradouro || '', [Validators.required]],
      municipality: [hiperdia?.municipio_id ? Number(hiperdia.municipio_id) : null, [Validators.required]],
      number: [hiperdia?.numero || '', [Validators.required]],
      email: [hiperdia?.email || '', [Validators.required]],
      phone_number: [cleanPhone(hiperdia?.telefone_1), [Validators.required]],
      phone_number_whatsapp: [cleanPhone(hiperdia?.telefone_whatsapp), [Validators.required]],
      password: ['••••••'],
      cnpj: [hiperdia?.cnpj || '', [Validators.required]],
      postal_code: [hiperdia?.cep || '', [Validators.required, Validators.minLength(8)]],
      city: [hiperdia?.cidade || ''],
      state: [hiperdia?.estado || '', [Validators.required]],
      neighborhood: [hiperdia?.bairro || '', [Validators.required]],
      active: [hiperdia?.status === 1 || hiperdia?.status === "1" || hiperdia?.status_id === 1 || hiperdia?.status_id === "1"],
    })
  }
  getAddressByPostalCode() {
    let postalCode = this.form.get('postal_code')?.value
    if (postalCode != '' && postalCode.length >= 8) {
      this.viaCepService.getAdressbyPostalCode(postalCode).subscribe({
        next: (response: any) => {
          this.fillFormViaCep(response)
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
        },
      })
    }
  }
  fillFormViaCep(element: any) {
    if (element.erro) {
    } else {
      this.form.get('street')?.setValue(element.logradouro)
      this.form.get('number')?.setValue('')
      this.form.get('neighborhood')?.setValue(element.bairro)
      this.form.get('city')?.setValue(element.localidade)
      this.form.get('state')?.setValue(element.estado)
    }
  }
  editLocation() {
    this.loading = true
    this.municipalityCentralService.editMunicipality(this.createModel()).subscribe({
      next: (response: ResponseRequestModel) => {
        this.snackbar.success(response.message)
        this.responseEdit.emit()
        this.close()
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
      },
    })
  }
}
